<template>
    <header class="header-wrapper">
        <div v-if="!authData.isLoggedIn" class="header-con">
            <nav class="navbar navbar-expand-lg navbar-light ">
                <div class="container-fluid">
                    <div class="header-logo">
                        <router-link class="navbar-brand" to="/agent"><img src="/Agent/images/logo.png" alt=""></router-link>
                    </div>
                    <div class="header-nav-con">
                        <div class="header-menu">
                            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                                data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false"
                                aria-label="Toggle navigation">
                                <div class="hamburger">
                                    <input type="checkbox" class="hamburger-init">
                                    <div class="menu">
                                        <div class="bar1"></div>
                                        <div class="bar2"></div>
                                        <div class="bar3"></div>
                                    </div>
                                </div>
                            </button>
                            <div class="collapse navbar-collapse" id="navbarText">
                                <ul class="navbar-nav m-auto  navbar-nav-scroll">
                                    <li class="nav-item">
                                        <router-link class="nav-link active" to="/agent"> Home</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link " href="#" @click="scrollToServiceSection('service-sec')">
                                            Service</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link " href="#"
                                            @click="scrollToServiceSection('testimonials-sec')">
                                            Testimonials</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link " href="#" @click="scrollToServiceSection('contact-sec')">
                                            Contact Us</a>
                                    </li>
                                </ul>
                                <form class="d-flex">
                                    <div class="social-content-sec">
                                        <button class=" thm-social-btn"> <img src="/Agent/images/call-icon.svg" alt="">
                                            <span> +91-6269010321, 22</span></button>
                                        <button class=" thm-social-btn"> <img src="/Agent/images/whatsapp-icon.svg"
                                                alt="">
                                            <span> +91-6269010323</span></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="header-login">
                            <div class="login-btn">
                                <button class="thm-btn" data-bs-toggle="modal"
                                    data-bs-target="#loginmodal">Login</button>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

        </div>
        <div v-else class="header-con">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="container-fluid custom-container">
                    <div class="header-after-login">

                        <div class="header-logo">
                            <router-link class="navbar-brand" to="/agent"><img src="/Agent/images/logo.png"
                                    alt=""></router-link>
                        </div>

                        <div class="header-after-right">
                            <div class="search-sec">
                                <input type="text" id="search1" placeholder="Smart Search...">
                                <button class="search-btn"><img src="/Agent/images/search-icon.svg" alt=""></button>
                            </div>

                            <div class="header-sub-right">

                                <div class="seating-and-profile">

                                    <div class="box-btn-sec" v-if="false">
                                        <div class="dropdown">
                                            <button class="box-btn-thm" type="button" id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="/Agent/images/setting-icon.svg" alt="">
                                            </button>
                                            <div class="box-dropdown-con dropdown-menu dropdown-menu-lg-end"
                                                aria-labelledby="dropdownMenuButton1">
                                                <div class="box-dropdown-heading">
                                                    <h6 class="thm-heading-paragraph">Settings</h6>
                                                </div>
                                                <div class="box-dropdown-list">
                                                    <ul>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Mail Notification</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Web check-in</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Manage employee</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Form16</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">User manual</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Change logo</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Set balance alert</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Update my GST</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Download GST</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Saved GST Details new</a>
                                                        </li>
                                                        <li class="dropdown-item"><a href="#" class="thm-heading-paragraph">Manage traveller new</a></li>
                                                    </ul>
                                                </div>
                                                <div class="box-dropdown-heading box-dropdown-sub-heading">
                                                    <h6 class="thm-heading-paragraph">Support</h6>
                                                </div>
                                                <div class="box-dropdown-list">
                                                    <ul>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">dreasyfly.com Customer
                                                                Care</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Airline Contacts</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="box-btn-sec notification-sec" v-if="false">
                                        <div v-if="showTooltip" class="notification-tooltip">
                                            <span class="thm-heading-small">Do not disturb</span>
                                        </div>
                                        <div class="dropdown">

                                            <button class="box-btn-thm" type="button" id="dropdownMenunotification"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="/Agent/images/notification-icon.svg" alt="">

                                            </button>
                                            <div class="box-dropdown-con dropdown-menu dropdown-menu-lg-end"
                                                aria-labelledby="dropdownMenunotification">
                                                <div class="box-dropdown-heading form-check form-switch "
                                                    @mouseover="showTooltip = true" @mouseleave="showTooltip = false">
                                                    <label class="form-check-label thm-heading-paragraph"
                                                        for="flexSwitchCheckDefault">Notification</label>
                                                    <input class="form-check-input" type="checkbox"
                                                        id="flexSwitchCheckDefault">
                                                </div>
                                                <div class="box-dropdown-list">

                                                    <ul>
                                                        <li class="dropdown-item">
                                                            <div class="notification-dropdown-list">
                                                                <h6 class="thm-heading-paragraph"> Brigis dawson
                                                                    followded
                                                                    you</h6>
                                                                <span class="thm-heading-small">23 Oct 2023</span>
                                                            </div>
                                                        </li>
                                                        <li class="dropdown-item">
                                                            <div class="notification-dropdown-list">
                                                                <h6 class="thm-heading-paragraph"> Brigis dawson
                                                                    followded
                                                                    you</h6>
                                                                <span class="thm-heading-small">23 Oct 2023</span>
                                                            </div>
                                                        </li>
                                                        <li class="dropdown-item">
                                                            <div class="notification-dropdown-list">
                                                                <h6 class="thm-heading-paragraph"> Brigis dawson
                                                                    followded
                                                                    you</h6>
                                                                <span class="thm-heading-small">23 Oct 2023</span>
                                                            </div>
                                                        </li>
                                                        <li class="dropdown-item">
                                                            <div class="notification-dropdown-list">
                                                                <h6 class="thm-heading-paragraph"> Brigis dawson
                                                                    followded
                                                                    you</h6>
                                                                <span class="thm-heading-small">23 Oct 2023</span>
                                                            </div>
                                                        </li>
                                                        <li class="dropdown-item">
                                                            <div class="notification-dropdown-list">
                                                                <h6 class="thm-heading-paragraph"> Brigis dawson
                                                                    followded
                                                                    you</h6>
                                                                <span class="thm-heading-small">23 Oct 2023</span>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="box-btn-sec profile-sec">
                                        <div class="dropdown">
                                            <button class="box-btn-thm" type="button" id="dropdownMenuuser"
                                                data-bs-toggle="dropdown" aria-expanded="false">
                                                <img src="/Agent/images/user-img.jpg" alt="">
                                            </button>
                                            <div class="box-dropdown-con dropdown-menu dropdown-menu-lg-end"
                                                aria-labelledby="dropdownMenuuser">
                                                <div class="box-dropdown-heading">
                                                    <h6 class="thm-heading-paragraph">ID - {{ userDetail.uuid }}</h6>
                                                </div>
                                                <div class="box-dropdown-list">
                                                    <ul>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Change password</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">My Profile</a></li>
                                                    </ul>
                                                </div>
                                                <div class="box-dropdown-heading box-dropdown-sub-heading">
                                                    <h6 class="thm-heading-paragraph">Accounts</h6>
                                                </div>
                                                <div class="box-dropdown-list">
                                                    <ul>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Transaction log</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Upload balance</a></li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Credit limit request </a>
                                                        </li>
                                                        <li class="dropdown-item">
                                                            <a href="#" class="thm-heading-paragraph"
                                                                @click.prevent="navigateLedger">My ledger</a>
                                                        </li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Credit note history </a>
                                                        </li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph">Bank account details </a>
                                                        </li>
                                                        <li class="dropdown-item"><a href="#"
                                                                class="thm-heading-paragraph" @click="Logout">Logout
                                                            </a></li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="balance-credit-sec">
                                    <div class="balance-credit-toggle">
                                        <div class="box-btn-sec">
                                            <button class="box-btn-thm balance-credit-btn" @click="toggleVisibility">
                                                <img src="/Agent/images/balance-credit-menu.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                    <div class="balance-credit-dropdown" :class="{ hide: isHidden }">
                                        <div class="balance-dropdown">

                                            <div class="dropdown dropdown-btn-sec">
                                                <button class=" dropdown-arrow dropdown-toggle" type="button"
                                                    id="dropdownMenuuser" data-bs-toggle="dropdown"
                                                    aria-expanded="false">
                                                    Balance : <span>{{ parseInt(agentBalance?.wallet_balance ||0) }}</span>
                                                    <div class="dropdown-btn-icon">
                                                        <span><img src="/Agent/images/wallet-icon.svg" alt=""></span>
                                                    </div>
                                                </button>
                                                <div class="box-dropdown-con dropdown-menu dropdown-menu-lg-end"
                                                    aria-labelledby="dropdownMenuuser">

                                                    <div class="box-dropdown-heading ">
                                                        <h6 class="thm-heading-paragraph">Balance</h6>
                                                    </div>
                                                    <div class="box-dropdown-list">
                                                        <ul>
                                                            <li class="dropdown-item"><a href="#"
                                                                    class="thm-heading-paragraph"> Upload balance</a>
                                                            </li>
                                                            <li class="dropdown-item"><a href="#"
                                                                    class="thm-heading-paragraph">Instant Rechargee</a>
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="credit-dropdown">

                                            <div class="dropdown dropdown-btn-sec">
                                                <button class=" dropdown-arrow dropdown-toggle" type="button"
                                                    id="dropdownMenuuser" data-bs-toggle="dropdown"
                                                    aria-expanded="false">
                                                    Credit : <span>{{ agentBalance?.credit_limit ||0 }}</span>
                                                    <div class="dropdown-btn-icon">
                                                        <span><img src="/Agent/images/money-icon.svg" alt=""></span>
                                                    </div>
                                                </button>
                                                <div class="box-dropdown-con dropdown-menu dropdown-menu-lg-end"
                                                    aria-labelledby="dropdownMenuuser">

                                                    <div class="box-dropdown-heading ">
                                                        <h6 class="thm-heading-paragraph">Balance</h6>
                                                    </div>
                                                    <div class="box-dropdown-list credit-balance-item">
                                                        <ul>
                                                            <li class="dropdown-item">
                                                                <span class="thm-heading-paragraph">Limit</span>
                                                                <span class="thm-heading-paragraph">{{
            agentBalance?.credit_limit || 0 }}</span>
                                                            </li>

                                                            <li class="dropdown-item">
                                                                <span class="thm-heading-paragraph">Due</span>
                                                                <span class="thm-heading-paragraph">{{
            agentBalance?.due_amount || 0}}</span>
                                                            </li>
                                                            <li class="dropdown-item">
                                                                <span class="thm-heading-paragraph">Limit Left</span>
                                                                <span class="thm-heading-paragraph">{{
            agentBalance?.credit_limit || 0 }}</span>
                                                            </li>
                                                            <li class="dropdown-item"
                                                                v-if="agentBalance?.credit_expiry_date">
                                                                <span class="thm-heading-paragraph">Exp </span>
                                                                <span class="thm-heading-paragraph">{{formattedCreditExpiryDate(agentBalance?.credit_expiry_date)}}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="box-dropdown-list box-dropdown-sub-heading ps-0">
                                                        <ul>
                                                            <li class="dropdown-item"><a href="#"
                                                                    class="thm-heading-paragraph">Request Credit</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="switch-portal-btn-sec">
                                    <button class="thm-btn switch-portal-btn" @click="switchToOldPortal" title="Switch to old portal">
                                        <span>← Old Portal</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </nav>
        </div>
    </header>



    <section class="success-wrapper " v-if="trainStore.isSuccessToaster">
        <div class="success-sec">
            <div class="success-img">
                <img src="/Agent/images/success-icon.svg" alt="">
            </div>
            <div class="success-con">
                <h3 class="thm-heading-paragraph">Success!</h3>
                <p class="thm-heading-small">{{ trainStore.toastrMsg }}</p>
            </div>
        </div>
    </section>



    <section class="wrong-wrapper" v-if="trainStore.isDangerToaster">
        <div class="success-sec">
            <div class="success-img">
                <img src="/Agent/images/wrong-icon.svg" alt="">
            </div>
            <div class="success-con">
                <h3 class="thm-heading-paragraph">wrong !</h3>
                <p class="thm-heading-small">{{ trainStore.toastrMsg }}</p>
            </div>
        </div>
    </section>

    <!-- all the modals index page -->

    <div class="modal fade" ref="loginmodal"  id="loginmodal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered login-modal-sec">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-logo">
                        <router-link to="/"><img src="/Agent/images/logo.png" alt=""></router-link>
                    </div>
                    <div class="thm-heading text-center">
                        <h3 class="thm-heading-three">Welcome to Dreasyfly!</h3>
                        <span class="thm-heading-small ">Please log in to continue</span>
                    </div>

                    <form @submit.prevent="submitForm">
                        <div class="modal-sub-con">
                            <div class="modal-input">
                                <label for="email" class="form-label thm-heading-paragraph">Email </label>
                                <input type="text" class="form-control thm-heading-paragraph" id="email"
                                    placeholder="Enter email " v-model="email"
                                    :class="{ 'is-invalid': emailError }" autocomplete="off">
                                <div v-if="emailError" class="error thm-heading-small">{{ emailError }}</div>
                            </div>
                            <div class="modal-input">
                                <label for="password" class="form-label thm-heading-paragraph">Password </label>
                                <input type="password" class="form-control thm-heading-paragraph"
                                    placeholder="Enter Password" id="password" v-model="password"
                                    :class="{ 'is-invalid': passwordError }">
                                <div v-if="passwordError" class="error thm-heading-small">{{ passwordError }}</div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <!-- <button class="thm-btn" type="submit">login</button> -->

                            <button class="thm-btn" type="submit" :disabled="isLoggingIn">
                                <span v-if="!isLoggingIn">Login</span>
                                <span v-else>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Logging in...
                                </span>
                            </button>

                        </div>
                    </form>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

// import axios from 'axios';
import { traindata } from '../../agent/store'
import { watch } from 'vue';
// import ApiService from '../services/ApiService'
// import { agentStore } from '../../agent/store';
import ProfileServices from '../profile/services/ProfileService';
import { agentStore } from '../../agent/store';
import moment from 'moment';
export default { 
    name: "HeaderView",
    setup() {
        const authData = agentStore();
        let isLoggedIn = authData.$state.isLoggedIn

        let trainStore = traindata();
        let isSuccessToaster = trainStore.isSuccessToaster;
        let toastrMsg = trainStore.toastrMsg
        let isDangerToaster = trainStore.isDangerToaster;
        watch(
            () => authData.$state.isLoggedIn, () => {
                isLoggedIn = false;
            },
            () => trainStore.$state.isSuccessToaster, (newValue) => {
                isSuccessToaster = newValue;
            },
            () => trainStore.$state.toastrMsg, (newValue) => {
                toastrMsg = newValue;
            },
            () => trainStore.$state.isDangerToaster, (newValue) => {
                isDangerToaster = newValue;
            },

        )
        authData.isLoggedIn = isLoggedIn;
        trainStore.isSuccessToaster = isSuccessToaster;
        trainStore.toastrMsg = toastrMsg;
        trainStore.isDangerToaster = isDangerToaster;
        return { trainStore,authData }


    },
    data() {
        return {
            isLoggingIn: false,
            isHidden: true,
            isNavbarOpen: false,
            isDropdownOpen: false,
            showTooltip: false,
            email: '',
            password: '',
            emailError: '',
            passwordError: '',
            wrongError: '',
            successMessage: '',
            userDetail: this.authData.$state.UserData,
            agentBalance1: {
                credit_expiry_date: '0',
                wallet_balance: '0',
                due_amount: '0',
                credit_limit: '0'
            },
            agentBalance: this.authData.$state.agentBalance,

        }

    },

    async created() {
        // this.fetchAgentBalance()
    },

    watch: {
        'authData.$state.isLoggedIn': function (newVal) {
            if (newVal) {
                this.fetchAgentBalance();
            }
        }
    },


    methods: {

        toggleNavbar() {
            this.isNavbarOpen = !this.isNavbarOpen;
        },
        scrollToServiceSection(val) {
            const serviceSection = document.getElementById(val);
            if (serviceSection) {
                serviceSection.scrollIntoView({ behavior: 'smooth' });
            }
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        toggleVisibility() {
            this.isHidden = !this.isHidden;
        },
        showContent() {
        },

        formattedCreditExpiryDate(date) {
            if (!date || typeof date !== 'string') {
                return '';
            }

            // ISO format (2026-02-15T00:00:00)
            if (moment(date, moment.ISO_8601, true).isValid()) {
                return moment(date).format('DD-MMM-YYYY');
            }

            // DD-MM-YYYY or D-M-YYYY
            if (moment(date, 'D-M-YYYY', true).isValid()) {
                return moment(date, 'D-M-YYYY', true).format('DD-MMM-YYYY');
            }

            // MM/YY (credit card expiry etc.)
            if (moment(date, 'MM/YY', true).isValid()) {
                return moment(date, 'MM/YY', true).format('MM/YY');
            }

            return '';
        },
        async submitForm() {
            this.emailError = '';
            this.passwordError = '';
            this.wrongError = '';
            this.successMessage = '';

            // Validation
            if (!this.email) {
                this.emailError = 'Please enter your email.';
                return;
            }
            if (!this.password) {
                this.passwordError = 'Please enter your password.';
                return;
            }

            // ✅ Set loading state
            this.isLoggingIn = true;

            try {
                this.$root.toggleLoader(true); // Optional global loader – you can keep or remove
                let LoginResponse = await ProfileServices.login(this.email, this.password);
                if (LoginResponse.status == 0) {
                    // ❌ Login failed
                    this.wrongError = LoginResponse?.message || '';
                    alert(LoginResponse.message); // Or show toast
                    // Show wrong toast
                    const wrongItems = document.querySelectorAll('.wrong-wrapper');
                    wrongItems.forEach(item => {
                        item.classList.add('show');
                        setTimeout(() => {
                            item.classList.remove('show');
                        }, 5000);
                    });
                    this.password = ""; // clear password
                    // ❌ Reset loading – button reverts to "Login"
                    this.isLoggingIn = false;
                } else {
                    // ✅ Login success
                    this.successMessage = LoginResponse.message;
                    // Show success toast
                    const successItems = document.querySelectorAll('.success-wrapper');
                    successItems.forEach(item => {
                        item.classList.add('show');
                        setTimeout(() => {
                            item.classList.remove('show');
                        }, 2000);
                    });

                    // Close modal
                    document.getElementById('loginmodal')?.classList.remove("show");
                    this.$refs.loginmodal.style.display = 'none';
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop) {
                        backdrop.parentNode.removeChild(backdrop);
                    }
                    const body = document.querySelector('body');
                    body.style.cssText = '';

                    // Store user data
                    this.authData.setLogin(LoginResponse.token, LoginResponse?.data[0] || '');
                    this.authData.$state.WalletBalance = parseInt(this.agentBalance?.wallet_balance || 0);

                    // Reset form
                    this.resetForm();

                    // ✅ Reset loading before redirect (optional)
                    this.isLoggingIn = false;

                    // Redirect
                    this.$router.push({ name: 'agenthome' });
                }
            } catch (error) {
                // ❌ Network / other error
                console.error("Login error:", error);
                let message = 'Technical error, please try again later';
                if (error.code === 'ERR_NETWORK') {
                    message = 'Server is down, please try again later';
                }
                alert(message);
                // ❌ Reset loading
                this.isLoggingIn = false;
            } finally {
                // ✅ Ensure loading is reset in all cases (extra safety)
                this.isLoggingIn = false;
                this.$root.toggleLoader(false); // if you used global loader
            }
        },

        resetForm() {
            this.email = '';
            this.password = '';
        },
        navigateLedger() {
            this.$router.push({ name: 'myLedgerView' });
        },
        async Logout() { 
            this.$root.toggleLoader(true);
            this.wrongError = '';
            let logoutResp = await ProfileServices.logout();

            if (logoutResp && logoutResp.status == 1 || (logoutResp.status == 0  && logoutResp.doLogout == 1)) {
                this.$root.toggleLoader(false);
                this.authData.$state.token = null;
                this.authData.$state.isLoggedIn = false;
                this.authData.$state.UserData = {};
                this.authData.$state.WalletBalance = 0;
                this.$router.push({ name: 'AgentPublicHome' })
                return false;
            }
            
            this.wrongError = logoutResp.message;
            const wrongItems = document.querySelectorAll('.wrong-wrapper');

            this.password = "";
            wrongItems.forEach(item => {
                item.classList.add('show');
                setTimeout(() => {
                    item.classList.remove('show');
                }, 5000);
            });
            

        },
        async fetchAgentBalance() {
            try {
                let agentBalanceResponse = await ProfileServices.getAgentBalance();
                if (agentBalanceResponse && agentBalanceResponse.status === 1) {
                    if (Array.isArray(agentBalanceResponse.data) && agentBalanceResponse.data.length > 0) {
                        this.agentBalance = agentBalanceResponse.data[0];
                        this.authData.$state.agentBalance = this.agentBalance;
                        
                    }
                }
            } catch (error) {
                // console.error('Error fetching agent balance:', error);
            }
        },
        switchToOldPortal() {
            const oldPortalUrl = 'https://www.dreasyfly.com';
            window.location.href = oldPortalUrl;
        }

    }
}


</script>